/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * smoothScrollTrigger.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * スムーススクロール
 */
const smoothScrollTo = () => {
  let anchorLinks = document.querySelectorAll('a[data-anchor="true"]');
  const anchorLinksArr = Array.prototype.slice.call(anchorLinks);
  const headerHeight = document.querySelector('header').offsetHeight;

  anchorLinksArr.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      const href = e.currentTarget.getAttribute("href");
      const targetId = href.substring(href.indexOf("#"));
      const targetOffsetTop = !targetId ? 0 : window.pageYOffset + document.querySelector(targetId).getBoundingClientRect().top;
      window.scrollTo({
        top: targetOffsetTop,
        behavior: "smooth",
      });
    });
  });
};

export {
  smoothScrollTo
};